import { Account } from '../../order/models/account.model';
import { WarehouseLocation } from '../../warehousing/models/warehouse-location.model';

export class DepotStockLocation {
  id: number = -1;

  account: Account = new Account();
  accountId: number = -1;

  warehouseLocation: WarehouseLocation = new WarehouseLocation();
  warehouseLocationId: number = -1;

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
